export default () => {
  $('#twenty').twentytwenty();
};
